import React, { useState, useEffect } from "react";
import { Container } from "react-bootstrap";
import { Row, Col, Card } from "react-bootstrap";
import aviator from "../../../images/landing01.webp";
import roulette from "../../../images/roulette.jpg";
import quiz from "../../../images/quiz.jpg";
import calc from "../../../images/calc.jpg";
import crossLog from "../../../images/cclogo.webp";
import obstacle from "../../../images/obstacle.webp";
import "./portfolio.scss";

function Portfolio() {
  const [scroll, setScroll] = useState(false);
  const [active, setActive] = useState("All");
  const handleScroll = () => {
    if (window.pageYOffset > 200) {
      setScroll(true);
    } else {
      setScroll(false);
    }
  };
  useEffect(() => {
    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  });

  const AddClass = (element, name) => {
    let i, arr1, arr2;
    arr1 = element.className.split(" ");
    arr2 = name.split(" ");
    for (i = 0; i < arr2.length; i++) {
      if (arr1.indexOf(arr2[i]) === -1) {
        element.className += " " + arr2[i];
      }
    }
  };
  const RemoveClass = (element, name) => {
    var i, arr1, arr2;
    arr1 = element.className.split(" ");
    arr2 = name.split(" ");
    for (i = 0; i < arr2.length; i++) {
      while (arr1.indexOf(arr2[i]) > -1) {
        arr1.splice(arr1.indexOf(arr2[i]), 1);
      }
    }
    element.className = arr1.join(" ");
  };

  const filterSelection = (c) => {
    let x;
    let i;

    x = document.getElementsByClassName("filterDiv");
    if (c === "all") c = "";
    for (i = 0; i < x.length; i++) {
      RemoveClass(x[i], "show");
      if (x[i].className.indexOf(c) > -1) {
        AddClass(x[i], "show");
      }
    }
  };

  filterSelection("all");

  const btns = document.querySelectorAll(".filters-list-item");
  for (let i = 0; i < btns.length; i++) {
    btns[i].addEventListener("click", (e) => {
      setActive(e.target.innerText);
    });
  }

  return (
    <section id="portfolio" className="portfolio section">
      <Container className="py-5">
        <h1 className={scroll ? "" : ""}>
          Featured <span>Portfolio</span>
        </h1>
        <div className="filters">
          <ul className="filters-list">
            <li
              onClick={() => filterSelection("all")}
              className={active === "All" ? "filters-list-item active" : "filters-list-item"}
            >
              All
            </li>
            <li
              onClick={() => filterSelection("website")}
              className={active === "Website" ? "filters-list-item active" : "filters-list-item"}
            >
              Website
            </li>
            <li
              onClick={() => filterSelection("small-projects")}
              className={
                active === "Small projects" ? "filters-list-item active" : "filters-list-item"
              }
            >
              Small projects
            </li>
          </ul>
        </div>
        <Container>
          <Row className="mt-5 text-center portfolio-container">
            <Col className="filterDiv small-projects scale-from">
              <Card className="filterDiv-container">
                <Card.Img src={roulette} variant="top" />
                <Card.Body>
                  <Card.Title>
                    <a href="https://roulette-w.web.app/" rel="noreferrer" target="_blank">
                      Roulette
                    </a>
                  </Card.Title>
                  <span>Small Projects</span>
                </Card.Body>
              </Card>
            </Col>

            <Col className="filterDiv small-projects scale-from">
              <Card className="filterDiv-container">
                <Card.Img src={quiz} variant="top" />
                <Card.Body>
                  <Card.Title>
                    <a href="https://quiz-app-w.web.app/" rel="noreferrer" target="_blank">
                      Quizz App
                    </a>
                  </Card.Title>
                  <span>Small Projects</span>
                </Card.Body>
              </Card>
            </Col>

            <Col className="filterDiv small-projects scale-from">
              <Card className="filterDiv-container">
                <Card.Img src={calc} variant="top" />
                <Card.Body>
                  <Card.Title>
                    <a
                      href="https://income-calculation.web.app/"
                      className="income-tax"
                      rel="noreferrer"
                      target="_blank"
                    >
                      Income Calculation
                    </a>
                  </Card.Title>
                  <span>Small Projects</span>
                </Card.Body>
              </Card>
            </Col>
          </Row>
          <Row className="mt-5 text-center portfolio-container">
            <Col className="filterDiv website scale-from">
              <Card className="filterDiv-container">
                <Card.Img src={aviator} variant="top" />
                <Card.Body>
                  <Card.Title>
                    <a href="http://1209.ge/" rel="noreferrer" target="_blank">
                      Aeroclub Georgia
                    </a>
                  </Card.Title>
                  <span>Website</span>
                </Card.Body>
              </Card>
            </Col>
            <Col className="filterDiv website scale-from">
              <Card className="filterDiv-container">
                <Card.Img src={obstacle} variant="top" />
                <Card.Body>
                  <Card.Title>
                    <a href="http://obstaclesports.ge/" rel="noreferrer" target="_blank">
                      Obstacle Sports Georgia
                    </a>
                  </Card.Title>
                  <span>Website</span>
                </Card.Body>
              </Card>
            </Col>
            <Col className="filterDiv website scale-from">
              <Card className="filterDiv-container">
                <Card.Img src={crossLog} variant="top" />
                <Card.Body>
                  <Card.Title>
                    <a href="https://www.crosscreators.com/" rel="noreferrer" target="_blank">
                      Crosscreators
                    </a>
                  </Card.Title>
                  <span>Website</span>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </Container>
    </section>
  );
}

export default Portfolio;
